import React from "react";
import Icon from "carbon-react/lib/components/icon";

const SuccessFailureIcon = (props) => {
  const iconType = props.success ? "tick" : "warning";
  const iconColor = props.success
    ? { iconColor: "business-color" }
    : { className: `${props.className} warning-icon` };

  return <Icon {...props} type={iconType} {...iconColor} />;
};

export default SuccessFailureIcon;
